import HxForm from './src/index.vue'

HxForm.install = Vue => {
  Vue.component(HxForm.name, HxForm)
}

export default HxForm
